<template>
  <div class="campusDynamic-page">
    <div class="cross" v-if="screenType == 0">
     
      <!-- 图文 -->
      <graphicCampusDynamic :screenType="screenType" :data="currentData" v-if="currentData && currentData.showTypeValue == 1"></graphicCampusDynamic>
      <!-- 纯文字 -->
      <pureTextCampusDynamic :screenType="screenType" :data="currentData" v-if="currentData && currentData.showTypeValue == 2"></pureTextCampusDynamic>
      <!-- 大图 -->
      <bigCampusDynamic :screenType="screenType" :data="currentData"  v-if="currentData && currentData.showTypeValue == 4"></bigCampusDynamic>
      <!-- 视频 -->
      <videoCampusDynamic :screenType="screenType" :data="currentData"  v-if="currentData && currentData.showTypeValue == 3"></videoCampusDynamic>
    </div>
    <div v-else class="vertical">
      <!-- 图文 -->
      <graphicCampusDynamic :screenType="screenType" :data="currentData" v-if="currentData && currentData.showTypeValue == 1"></graphicCampusDynamic>
      <!-- 纯文字 -->
      <pureTextCampusDynamic :screenType="screenType" :data="currentData" v-if="currentData && currentData.showTypeValue == 2"></pureTextCampusDynamic>
      <!-- 大图 -->
      <bigCampusDynamic :screenType="screenType" :data="currentData"  v-if="currentData && currentData.showTypeValue == 4"></bigCampusDynamic>
      <!-- 视频 -->
      <videoCampusDynamic :screenType="screenType" :data="currentData"  v-if="currentData && currentData.showTypeValue == 3"></videoCampusDynamic>

    </div>
    <div
      class="left"
      :class="screenType == 1 ? 'verticalLeft' : ''"
      @click="clickCrossLeftImg"
    >
      <dsf-icon :class="leftClouldRedClass" class="icon-fanyezuobeifen8" />
    </div>
    <div
      class="right"
      :class="screenType == 1 ? 'verticalRight' : ''"
      @click="clickCrossRightImg"
    >
      <dsf-icon :class="rightClouldRedClass" class="icon-fanyezuobeifen5" />
    </div>
  </div>
</template>

<script>
import bigCampusDynamic from "./bigCampusDynamic.vue"
import graphicCampusDynamic from "./graphicCampusDynamic.vue"
import pureTextCampusDynamic from "./pureTextCampusDynamic.vue"
import videoCampusDynamic from "./videoCampusDynamic.vue"

export default {
  name: "campusDynamic",
  components: {
    bigCampusDynamic,
    graphicCampusDynamic,
    pureTextCampusDynamic,
    videoCampusDynamic
  },
  data() {
    return {
      swiperList: [{ content: "", picture: [] }],
      screenType: 0, //屏幕类型：0为横向，1为纵向
      currentIndex: 0,
      currentData: {},
      leftClouldRedClass: "",
      rightClouldRedClass: "",
    };
  },
  created() {
    this.screenType = this.$route.meta.screenType;
    this.getData();
  },
  methods: {
    //图文和视频信息，页面详情
    getData() {
      var equipmentTypeValue = 1;
      if (this.screenType == 1) {
        equipmentTypeValue = 2
      }
      var params = {
        equipmentTypeValue: equipmentTypeValue, // 屏幕类型
        releaseTypeValue: 2,
      };
      this.$http.get("/teas/screen/getInformation", params)
      .done((res) => {
        if (res.success) {
          this.swiperList = res.data;
          this.currentData = this.swiperList[0];
          if (this.screenType == 0) {
            if (this.swiperList.length > 1) {
              this.rightClouldRedClass = "redClass";
            }
          } else {
            if (this.swiperList.length > 1) {
              this.rightClouldRedClass = "orangeClass";
            }
          }
        } else {
          dsf.layer.message(data.message, false);
        }
      });
      //   }
      // });
    },
    // 横屏点击方法
    clickCrossRightImg() {
      if (this.currentIndex == this.swiperList.length - 1) {
        return;
      }
      this.currentIndex++;
      this.currentData = this.swiperList[this.currentIndex];
      if (this.currentIndex == this.swiperList.length - 1) {
        if (this.screenType == 0) {
          this.leftClouldRedClass = "redClass";
          this.rightClouldRedClass = "";
        } else {
          this.leftClouldRedClass = "orangeClass";
          this.rightClouldRedClass = "";
        }
      } else {
        if (this.screenType == 0) {
          this.leftClouldRedClass = "redClass";
          this.rightClouldRedClass = "redClass";
        } else {
          this.leftClouldRedClass = "orangeClass";
          this.rightClouldRedClass = "orangeClass";
        }
      }
    },
    clickCrossLeftImg() {
      if (this.currentIndex == 0) {
        return;
      }
      this.currentIndex--;
      this.currentData = this.swiperList[this.currentIndex];
      if (this.currentIndex == 0) {
        if (this.screenType == 0) {
          this.leftClouldRedClass = "";
          this.rightClouldRedClass = "redClass";
        } else {
          this.leftClouldRedClass = "";
          this.rightClouldRedClass = "orangeClass";
        }
      } else {
        if (this.screenType == 0) {
          this.leftClouldRedClass = "redClass";
          this.rightClouldRedClass = "redClass";
        } else {
          this.leftClouldRedClass = "orangeClass";
          this.rightClouldRedClass = "orangeClass";
        }
      }
    }
  },
};
</script>

<style>
</style>